import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../css/Search.css";
import axios from "axios";
import MyButton from "../components/MyButton";
import NoData from "../components/NoData";

function Search(props) {
  const [projects, setProjects] = useState([]);
  const [models, setModels] = useState([]);
  const [searchParams] = useSearchParams();
  const input = searchParams.getAll("input")[0];

  const navigate = useNavigate();

  useEffect(() => {
    if (!props.user.id || input === undefined) {
      navigate("/m2d");
    }
    axios({
      method: "post",
      url: `/api/m2d/search`,
      data: {
        title: input,
      },
    }).then((res) => {
      setProjects(res.data.projects);
      setModels(res.data.models);
    });
  }, [input, navigate, props.user.id]);

  const handleMore = (type, id) => {
    if (props.user.id) {
      navigate(`/m2d/${type}/${id}`);
    }
  };

  return (
    <>
      <div className="page-content">
        <div
          className="search-cate"
          hidden={projects.length === 0 ? true : false}
        >
          Projects
        </div>
        {projects.map((project) => {
          return (
            <div className="search" key={project.id}>
              <div className="search-title">{project.title}</div>
              <div className="search-desc">{project.description}</div>
              <div className="search-btn-area">
                <div className="search-cont"></div>
                <div
                  className="more-btn-area"
                  hidden={props.user.id ? false : true}
                >
                  <MyButton
                    className="more-btn"
                    id={project.id}
                    type="link"
                    onClick={() => handleMore("projects", project.id)}
                  >
                    More
                  </MyButton>
                </div>
              </div>
            </div>
          );
        })}

        <div
          className="search-cate"
          hidden={models.length === 0 ? true : false}
        >
          Models
        </div>
        {models.map((model) => {
          return (
            <div className="search" key={model.id}>
              <div className="search-title">{model.name}</div>
              <div className="search-desc">{model.details}</div>
              <div className="search-btn-area">
                <div className="search-cont"></div>
                <div
                  className="more-btn-area"
                  hidden={props.user.id ? false : true}
                >
                  <MyButton
                    className="more-btn"
                    id={model.id}
                    type="link"
                    onClick={() => handleMore("models", model.id)}
                  >
                    More
                  </MyButton>
                </div>
              </div>
            </div>
          );
        })}

        {projects.length === 0 && models.length === 0 ? (
          <NoData info="No project or model found" />
        ) : null}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
  };
};

export default connect(mapStateToProps)(Search);
